import { Outlet } from "react-router";

import { AppHeader } from "@/src/components/layout/AppHeader";
import { AppSidebar } from "@/src/components/layout/AppSidebar";
import { BreadcrumbProvider } from "@/src/contexts/BreadcrumbContext";

/**
 * Coque de l'administration : barre latérale, en-tête, contenu.
 *
 * C'est une **route de mise en page**, déclarée sous `RequireAuth` : tout écran
 * privé en hérite sans rien faire, et un écran ajouté au mauvais niveau se
 * remarque tout de suite — il apparaît sans navigation.
 *
 * ⚠️ `min-w-0` sur la colonne de contenu n'est pas décoratif : un enfant flex
 * a `min-width: auto`, donc un tableau large ou un long identifiant élargirait
 * la colonne au lieu de défiler, et pousserait la mise en page hors de l'écran.
 */
export function AppLayout() {
  return (
    // Le fournisseur enveloppe **l'en-tête et le contenu** : l'écran pose le
    // dernier maillon du fil, l'en-tête le lit. Monté plus bas, il ne serait
    // pas partagé ; monté dans `App.tsx`, il survivrait à la sortie de la coque.
    <BreadcrumbProvider>
      <div className="flex min-h-dvh bg-background">
        <AppSidebar />

        <div className="flex min-w-0 flex-1 flex-col">
          <AppHeader />

          <main className="flex-1 p-4 sm:p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </BreadcrumbProvider>
  );
}
